import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { map, Observable } from "rxjs";
import { AppSecurityService } from "../services";

// Per-menu route guard for the top-level area hubs (Operations, Billing, Sales, C Suite,
// Administrator). Attach with route data, e.g.
//   { path: 'billing', loadChildren: ..., canActivate: [AuthGuard, MenuGuard], data: { menu: 'billing' } }
// A route with no `menu` in data is allowed (no-op). Denied users go to /access-denied.
export const MenuGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {

    const router: Router = inject(Router);
    const appSecurityService: AppSecurityService = inject(AppSecurityService);
    const required = route.data?.['menu'] as string | undefined;

    return appSecurityService.ensureFeaturesLoaded().pipe(
        map(() => (!required || appSecurityService.hasMenu(required))
            ? true
            : router.createUrlTree(['/access-denied'], { queryParams: { returnUrl: state.url } }))
    );
}
